import { DIFFICULTY_LEVELS, QUESTION_TYPES } from '../questionTypes';

// 30 Preguntas del Músculo Trapecio
// 10 Básicas + 10 Generales + 10 Complejas

export const trapecioQuestions = [
  
  // ========== NIVEL BÁSICO (10) ==========
  
  {
    id: 10181,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Cuántas porciones tiene el músculo trapecio?",
    options: ["Dos", "Tres", "Cuatro", "Cinco"],
    correctAnswer: 1,
    explanation: "El trapecio tiene tres porciones: superior (descendente), media (transversa) e inferior (ascendente). Esta disposición triangular le permite múltiples acciones sobre la escápula y la columna cervical. Es el músculo más superficial de la espalda y uno de los más grandes."
  },
  
  {
    id: 10182,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Dónde se origina la porción superior del trapecio?",
    options: [
      "Protuberancia occipital externa",
      "Apófisis espinosas de C1-C6",
      "Línea nucal superior del occipital",
      "Apófisis mastoides"
    ],
    correctAnswer: 2,
    explanation: "La porción superior del trapecio se origina en la línea nucal superior del hueso occipital, ligamento nucal y apófisis espinosas de C1 a C6. Esta inserción craneal le permite elevar la escápula y extender el cuello."
  },
  
  {
    id: 10183,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Cuál es la acción principal de la porción superior del trapecio?",
    options: [
      "Depresión escapular",
      "Elevación escapular",
      "Adducción escapular",
      "Rotación inferior escapular"
    ],
    correctAnswer: 1,
    explanation: "La porción superior del trapecio es la principal elevadora de la escápula. Esta acción es importante para encoger los hombros y mantener la postura erecta. Es antagonista de la porción inferior del trapecio."
  },
  
  {
    id: 10184,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.INERVACION,
    question: "¿Qué nervio inerva al trapecio?",
    options: [
      "Nervio accesorio (XI par)",
      "Nervio dorsal de la escápula",
      "Plexo cervical (C2-C4)",
      "Nervio supraescapular"
    ],
    correctAnswer: 0,
    explanation: "El nervio accesorio (XI par craneal) inerva al trapecio. Este nervio emerge del foramen yugular y desciende posterior al esternocleidomastoideo para inervar el trapecio. La lesión del nervio accesorio causa 'hombro caído' característico."
  },
  
  {
    id: 10185,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué arteria irriga principalmente al trapecio?",
    options: [
      "Arteria carótida externa",
      "Arteria subclavia",
      "Arteria cervical transversa",
      "Arteria occipital"
    ],
    correctAnswer: 2,
    explanation: "La arteria cervical transversa, rama de la arteria subclavia, irriga principalmente el trapecio. Esta arteria superficial discurre horizontalmente sobre el músculo elevador de la escápula y proporciona irrigación a la porción superior del trapecio."
  },
  
  {
    id: 10186,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué músculo se encuentra profundo al trapecio?",
    options: [
      "Romboides",
      "Elevador de la escápula",
      "Dorsal ancho",
      "Todos los anteriores"
    ],
    correctAnswer: 3,
    explanation: "Profundo al trapecio se encuentran los romboides, elevador de la escápula y dorsal ancho. Esta disposición en capas permite movimientos complejos de la escápula. El trapecio actúa como puente superficial sobre estos músculos más profundos."
  },
  
  {
    id: 10187,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Dónde se inserta la porción media del trapecio?",
    options: [
      "Acromion y espina escapular",
      "Clavícula y acromion",
      "Apófisis espinosas de T1-T4",
      "Borde medial de la escápula"
    ],
    correctAnswer: 0,
    explanation: "La porción media del trapecio se inserta en el acromion, espina de la escápula y ligamento acromioclavicular. Esta inserción escapular le permite retracción y aducción de la escápula, estabilizando el hombro durante movimientos del brazo."
  },
  
  {
    id: 10188,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Dónde se origina la porción inferior del trapecio?",
    options: [
      "Apófisis espinosas de T5-T12",
      "Apófisis espinosas de T1-T4",
      "Línea nucal superior",
      "Apófisis mastoides"
    ],
    correctAnswer: 0,
    explanation: "La porción inferior del trapecio se origina en las apófisis espinosas de T5 a T12. Esta inserción torácica inferior le permite descender y rotar inferiormente la escápula, siendo importante en la elevación del brazo por encima de la horizontal."
  },
  
  {
    id: 10189,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Qué acción realiza la porción inferior del trapecio?",
    options: [
      "Elevación escapular",
      "Descenso y rotación inferior escapular",
      "Adducción escapular",
      "Rotación superior escapular"
    ],
    correctAnswer: 1,
    explanation: "La porción inferior del trapecio desciende y rota inferiormente la escápula. Esta acción es crucial para la elevación completa del brazo por encima de 90 grados. Es antagonista de la porción superior del trapecio."
  },
  
  {
    id: 10190,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Por qué el trapecio es importante en la postura?",
    options: [
      "Por su función estética",
      "Por su función estabilizadora de la escápula",
      "Por su función en la respiración",
      "Por su función en la masticación"
    ],
    correctAnswer: 1,
    explanation: "El trapecio es crucial para mantener la postura erecta porque estabiliza la escápula contra la caja torácica. Su tono constante mantiene los hombros en posición neutra y previene el 'hombro caído'. La debilidad trapecial causa alteraciones posturales y dolor cervical."
  },
  
  // ========== NIVEL GENERAL (10) ==========
  
  {
    id: 10191,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Cómo contribuyen las tres porciones del trapecio al movimiento escapular coordinado?",
    options: [
      "Trabajan independientemente",
      "Se activan secuencialmente según el movimiento",
      "Solo la porción media contribuye",
      "Trabajan simultáneamente en todos los movimientos"
    ],
    correctAnswer: 1,
    explanation: "Las tres porciones del trapecio se activan secuencialmente durante movimientos escapulares: la superior inicia la elevación, la media mantiene la retracción durante el movimiento, y la inferior completa la rotación inferior para elevación completa del brazo."
  },
  
  {
    id: 10192,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué músculos actúan como sinergistas del trapecio en la elevación escapular?",
    options: [
      "Elevador de la escápula",
      "Romboides",
      "Dorsal ancho",
      "Todos los anteriores"
    ],
    correctAnswer: 0,
    explanation: "El elevador de la escápula es el principal sinergista del trapecio en la elevación escapular. Ambos músculos trabajan coordinadamente para elevar la escápula, siendo el trapecio más fuerte pero el elevador más rápido. Los romboides ayudan en la retracción."
  },
  
  {
    id: 10193,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué rama específica de la arteria subclavia irriga la porción superior del trapecio?",
    options: [
      "Arteria vertebral",
      "Arteria torácica interna",
      "Arteria cervical superficial",
      "Arteria cervical transversa superficial"
    ],
    correctAnswer: 3,
    explanation: "La arteria cervical transversa superficial, rama de la arteria subclavia, irriga la porción superior del trapecio. Esta arteria superficial es palpable en el triángulo posterior del cuello y puede palparse durante la evaluación vascular."
  },
  
  {
    id: 10194,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.INERVACION,
    question: "¿Cómo se distribuye la inervación del nervio accesorio en el trapecio?",
    options: [
      "Inerva todas las porciones por igual",
      "Inerva principalmente la porción superior",
      "Inerva todas las porciones pero con ramas específicas",
      "Inerva solo la porción media"
    ],
    correctAnswer: 2,
    explanation: "El nervio accesorio inerva todas las porciones del trapecio pero con ramas específicas: rama superior para la porción superior, rama media para la porción media, y rama inferior para la porción inferior. Esta distribución explica los déficits selectivos en lesiones parciales."
  },
  
  {
    id: 10195,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VARIANTE,
    question: "¿Cuál es la variante anatómica más común del trapecio?",
    options: [
      "Ausencia congénita",
      "Porción media ausente",
      "Inserción doble en la clavícula",
      "Fusión con el esternocleidomastoideo"
    ],
    correctAnswer: 1,
    explanation: "La ausencia de la porción media del trapecio es la variante más común, ocurriendo en 5-10% de la población. Los individuos con esta variante pueden tener dificultad para mantener la retracción escapular prolongada, compensando con los romboides."
  },
  
  {
    id: 10196,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué test clínico evalúa específicamente la función del trapecio superior?",
    options: [
      "Test de elevación escapular resistida",
      "Test de Yocum",
      "Test de Spurling",
      "Test de Adson"
    ],
    correctAnswer: 0,
    explanation: "El test de elevación escapular resistida evalúa la fuerza de la porción superior del trapecio. El paciente eleva los hombros contra resistencia aplicada desde arriba. Debilidad indica lesión del nervio accesorio o del músculo trapecio."
  },
  
  {
    id: 10197,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.EMBRIOLOGIA,
    question: "¿De qué arco faríngeo se desarrolla el trapecio?",
    options: [
      "Primer arco faríngeo",
      "Segundo arco faríngeo",
      "Tercer arco faríngeo",
      "Mesénquima occipital"
    ],
    correctAnswer: 1,
    explanation: "El trapecio se desarrolla del mesénquima del segundo arco faríngeo, al igual que el músculo esternocleidomastoideo. Esta origen común explica por qué ambos músculos están inervados por el nervio accesorio y comparten algunas características embriológicas."
  },
  
  {
    id: 10198,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.HISTOLOGIA,
    question: "¿Qué proporción aproximada de fibras musculares tiene el trapecio?",
    options: [
      "90% fibras tipo I",
      "70% fibras tipo II",
      "50% tipo I, 50% tipo II",
      "30% tipo I, 70% tipo II"
    ],
    correctAnswer: 2,
    explanation: "El trapecio tiene distribución equilibrada de fibras musculares (50% tipo I, 50% tipo II), adaptado para movimientos que requieren fuerza y resistencia postural. Las porciones superior e inferior tienen ligeramente más fibras tipo I para mantenimiento postural."
  },
  
  {
    id: 10199,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué estructura fascial cubre al trapecio?",
    options: [
      "Fascia cervical profunda",
      "Fascia toracolumbar",
      "Aponeurosis superficial",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "El trapecio está cubierto por la aponeurosis superficial, fascia cervical profunda y fascia toracolumbar. Esta cobertura fascial múltiple proporciona estabilidad y permite el deslizamiento durante movimientos. La fascia toracolumbar forma el 'tracto iliotibial' lateralmente."
  },
  
  {
    id: 10200,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Por qué el trapecio es importante en la rehabilitación de hombro?",
    options: [
      "Por su función estética",
      "Por su función estabilizadora escapular",
      "Por su función en la respiración",
      "Por su función en la deglución"
    ],
    correctAnswer: 1,
    explanation: "El trapecio es crucial en rehabilitación de hombro porque es el principal estabilizador escapular. Su fortalecimiento temprano previene inestabilidades y mejora la biomecánica del hombro. La debilidad trapecial causa alteraciones en el ritmo escapulohumeral."
  },
  
  // ========== NIVEL COMPLEJO (10) ==========
  
  {
    id: 10201,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente con antecedente de disección cervical radical presenta hombro caído y dificultad para elevar el brazo. ¿Qué nervio está lesionado?",
    options: [
      "Nervio dorsal de la escápula",
      "Nervio torácico largo",
      "Nervio accesorio",
      "Nervio supraescapular"
    ],
    correctAnswer: 2,
    explanation: "La lesión del nervio accesorio causa 'hombro caído' característico con protrusión medial de la escápula (escapula alata), debilidad para elevar el brazo y alteración de la marcha escapular. Es común en disecciones cervicales por la cercanía del nervio al campo quirúrgico."
  },
  
  {
    id: 10202,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Paciente con dolor cervical crónico presenta banda tensa dolorosa en trapecio superior. ¿Qué patología sugiere?",
    options: [
      "Fibromialgia",
      "Punto gatillo miofascial",
      "Tendinitis calcificante",
      "Rotura muscular"
    ],
    correctAnswer: 1,
    explanation: "Los puntos gatillo miofasciales en el trapecio superior causan dolor referido a cabeza, cuello y hombro. Son comunes en estrés postural crónico, malas posturas de computadora y sobrecarga laboral. Se tratan con masaje, estiramiento y punción seca."
  },
  
  {
    id: 10203,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué técnica se utiliza para reparar una ruptura completa del tendón del trapecio?",
    options: [
      "Sutura directa con anclas",
      "Transferencia tendinosa",
      "Reconstrucción con autoinjerto",
      "Liberación y alargamiento"
    ],
    correctAnswer: 0,
    explanation: "La ruptura completa del tendón del trapecio (rara) se repara con sutura directa reforzada con anclas óseas. Generalmente ocurre en la inserción acromial. La reparación temprana es crucial para restaurar la función escapular y prevenir deformidades permanentes."
  },
  
  {
    id: 10204,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En RM del cuello, ¿qué hallazgo confirma atrofia por denervación del trapecio?",
    options: [
      "Aumento de señal en T2-STIR",
      "Disminución de volumen muscular con grasa infiltrada",
      "Engrosamiento fascial",
      "Calcificaciones intratendinosas"
    ],
    correctAnswer: 1,
    explanation: "La atrofia por denervación del trapecio muestra disminución del volumen muscular con infiltración grasa en T1 (signo de 'muscle edema'). Es característica de lesión del nervio accesorio. La RM es superior a la ecografía para evaluar extensión de la denervación."
  },
  
  {
    id: 10205,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué complicación puede causar la contractura del trapecio superior?",
    options: [
      "Cefalea tensional",
      "Síndrome del desfiladero torácico",
      "Limitación de la rotación cervical",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "La contractura del trapecio superior puede causar cefalea tensional por tracción de inserciones occipitales, limitación de rotación cervical por tensión fascial, y contribuir al síndrome del desfiladero torácico por elevación crónica del hombro. Es común en estrés postural."
  },
  
  {
    id: 10206,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente con tumor parotídeo maligno requiere disección cervical radical. ¿Qué complicación funcional es más probable post-operatoria?",
    options: [
      "Disfagia",
      "Hombro caído por lesión del nervio accesorio",
      "Pérdida de audición",
      "Parálisis facial"
    ],
    correctAnswer: 1,
    explanation: "La disección cervical radical incluye resección del nervio accesorio, causando hombro caído característico con debilidad trapecial. Los pacientes tienen dificultad para elevar el brazo y alteración de la marcha escapular. La rehabilitación incluye fisioterapia y transferencias tendinosas."
  },
  
  {
    id: 10207,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Evaluación electromiográfica muestra denervación aguda del trapecio. ¿Qué segmento medular sugiere esto?",
    options: [
      "C1-C2",
      "C3-C4",
      "C5-C6",
      "T1-T2"
    ],
    correctAnswer: 0,
    explanation: "La denervación del trapecio indica lesión del nervio accesorio en su origen (C1-C2) o trayecto proximal. La EMG muestra potenciales de fibrilación y ondas positivas agudas. La lesión distal (después de la inervación del esternocleidomastoideo) afecta solo al trapecio."
  },
  
  {
    id: 10208,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué técnica se utiliza para reconstruir la función del trapecio paralizado?",
    options: [
      "Transferencia del elevador de la escápula",
      "Transferencia del dorsal ancho",
      "Transferencia del romboides mayor",
      "Todas las anteriores"
    ],
    correctAnswer: 1,
    explanation: "La transferencia del tendón del dorsal ancho al acromion restaura la elevación escapular en parálisis trapecial completa. El dorsal ancho se transfiere alrededor del borde lateral de la escápula y se tensa para proporcionar elevación activa. Es la técnica más utilizada para parálisis del nervio accesorio."
  },
  
  {
    id: 10209,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En ecografía dinámica del hombro, ¿qué maniobra evalúa la función del trapecio?",
    options: [
      "Elevación escapular resistida",
      "Abducción del hombro",
      "Rotación externa",
      "Flexión del codo"
    ],
    correctAnswer: 0,
    explanation: "La ecografía durante elevación escapular resistida evalúa la contractilidad del trapecio. Permite visualizar engrosamiento muscular durante contracción y detectar atrofia o lesiones. Es útil para evaluar función en tiempo real y comparar con el lado contralateral."
  },
  
  {
    id: 10210,
    muscle: 'trapecio',
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "Atleta con sobrecarga postural presenta hipertrofia compensatoria del trapecio superior. ¿Qué explica este hallazgo?",
    options: [
      "Adaptación neural",
      "Sobrecarga postural crónica",
      "Uso de esteroides",
      "Todas las anteriores"
    ],
    correctAnswer: 1,
    explanation: "La hipertrofia compensatoria del trapecio superior ocurre por sobrecarga postural crónica (trabajo de computadora, malas posturas). El trapecio superior se activa constantemente para mantener la cabeza erecta, causando hipertrofia desproporcionada. Puede causar dolor cervical y cefalea tensional."
  }
];
